import { useState } from "react";
import { FaSignOutAlt, FaUsers, FaTable, FaUserPlus, FaPlusSquare, FaCog, FaChevronUp, FaChevronDown, FaImage } from "react-icons/fa";
import SettingsModal from "./SettingsModal";
import { useDispatch, useSelector } from "react-redux";
import { loggOutUser } from "../store/userSlice";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DownloadGuestsPDFButton from "./DownloadGuestsPDFButton";

const ServiceSidebar = ({ activeForm, setActiveForm, guests, tables, hasReservations }) => {
    const { t, i18n } = useTranslation();
    const [showProfileModal, setShowProfileModal] = useState(false);
    const [settingsInitialTab, setSettingsInitialTab] = useState("personal");
    const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);

    const wedding = useSelector((state) => state.userStore.wedding);
    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch(loggOutUser());
        setShowLogoutConfirm(false);
    };

    const handleGuestsClick = () => {
        if (guests.length === 0) {
            setActiveForm("addGuest");
        } else {
            setActiveForm("guests");
        }
    };

    const handleTablesClick = () => {
        if (tables.length === 0) {
            setActiveForm("addTable");
        } else {
            setActiveForm("tables");
        }
    };

    const openSettings = (tab = "personal") => {
        setSettingsInitialTab(tab);
        setShowProfileModal(true);
    };

    const buttonClasses = (form) =>
        `flex items-center space-x-3 px-4 py-2 text-xl transition ${activeForm === form
            ? "bg-gradient-to-r from-rose-500 to-pink-600 hover:from-rose-600 hover:to-pink-700 shadow-lg shadow-rose-500/30 text-white"
            : "text-gray-800 hover:text-black hover:bg-gray-100 transition"
        }`;

    return (
        <>
            <div className="hidden lg:flex flex-col text-gray-800 w-72 h-screen fixed top-0 left-0 shadow-lg z-40 pb-7">
                <Link to="/">
                    <div className="text-2xl font-bold px-4 py-4 border-b border-gray-300 capitalize flex items-center gap-2">
                        <img src="/logo2.png" className="w-8 h-8 md:w-9 md:h-9" alt="Weddinfy" />
                        <span className="font-display text-xl md:text-[22px] font-semibold text-stone-900">Weddinfy</span>
                    </div>
                </Link>

                <div className="flex-1 flex flex-col py-6 space-y-2">
                    <button disabled={!wedding} onClick={handleGuestsClick} className={`${buttonClasses("guests")}`}>
                        <FaUsers className="text-lg" />
                        <span>{t("guests")}</span>
                        <span className="">{guests.length}</span>
                    </button>
                    <button disabled={!wedding} onClick={handleTablesClick} className={`${buttonClasses("tables")}`}>
                        <FaTable className="text-lg" />
                        <span>{t("tables")}</span>
                        <span className="">{tables.length}</span>
                    </button>
                    <button disabled={!wedding} onClick={() => setActiveForm("addGuest")} className={buttonClasses("addGuest")}>
                        <FaUserPlus className="text-lg" />
                        <span>{t("addGuest")}</span>
                    </button>
                    <button disabled={!wedding} onClick={() => setActiveForm("addFamily")} className={buttonClasses("addFamily")}>
                        <FaUsers className="text-lg" />
                        <span>Dodaj obitelj</span>
                    </button>
                    <button disabled={!wedding} onClick={() => setActiveForm("addTable")} className={buttonClasses("addTable")}>
                        <FaPlusSquare className="text-lg" />
                        <span>{t("addTable")}</span>
                    </button>
                    <button disabled={!wedding} onClick={() => openSettings("invitation")} className="flex items-center space-x-3 px-4 py-2 text-xl text-gray-800 hover:text-black hover:bg-gray-100 transition disabled:opacity-50">
                        <FaImage className="text-lg" />
                        <span>{t("tabInvitation")}</span>
                    </button>
                </div>

                <div className={!hasReservations ? "pointer-events-none opacity-50" : ""}>
                    <DownloadGuestsPDFButton />
                </div>

                <div className="border- border-gray-300 p-4 space-y-3 text-xl">
                    <button onClick={() => openSettings("personal")} className="flex items-center space-x-3 text-gray-800 hover:text-black transition">
                        <FaCog className="text-lg" />
                        <span>{t("settings")}</span>
                    </button>
                    <button onClick={() => setShowLogoutConfirm(true)} className="flex items-center space-x-3 text-red-600 hover:text-red-800 transition">
                        <FaSignOutAlt className="text-lg" />
                        <span>{t("logout")}</span>
                    </button>
                </div>
            </div>

            {showProfileModal && (
                <SettingsModal
                    onClose={() => setShowProfileModal(false)}
                    initialTab={settingsInitialTab}
                />
            )}

            {showLogoutConfirm && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-sm text-center space-y-4">
                        <h3 className="text-lg font-semibold text-gray-800">{t("logoutConfirmTitle")}</h3>
                        <div className="flex justify-end space-x-2 mt-4">
                            <button
                                onClick={handleLogout}
                                className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-700 transition"
                            >
                                {t("logout")}
                            </button>
                            <button
                                onClick={() => setShowLogoutConfirm(false)}
                                className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400 transition"
                            >
                                {t("cancel")}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ServiceSidebar;
